// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DynProperty } from "../../Commons/DynProperty.js";
import { Resources } from "../../Commons/properties/Resources.js";
import { EntitlementProductRequestStatus, EntitlementProductRequestStatusMap, EntitlementProductRequestTypeMap } from "../../Commons/cache/EntitlementPrimitives.js";
import { DateTimeUtils } from "../../Utils/Time/DateTimeUtils.js";
import { QuickTableColumnType, QuickTableEditingInfo } from "../elements/QuickTable/QuickTableMisc.js";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.js";
import { DataCache } from "../../Commons/DataCache.js";

export let EntitlementProductsItem = function (requestData, sessionSettings, colors)
{
    BaseItem.call(this, sessionSettings);

    this.requestData = requestData;
    if (colors)
    {
        if (colors[1])
            this.CellForeColorMap[1] = colors[1]
        if (colors[2])
            this.CellForeColorMap[2] = colors[2]
    }
    this.QuickTableEditingInfoMap[5] = (function ()
    {
        return new QuickTableEditingInfo(DynProperty.CLOSE_BUTTON);
    })();
};

EntitlementProductsItem.prototype = Object.create(BaseItem.prototype);

EntitlementProductsItem.prototype.ColumnCount = function ()
{
    return EntitlementProductsItem.columnsParams.length;
};

EntitlementProductsItem.prototype.getColumnData = function (column)
{
    let value = this.getColumnValue(column);
    let formattedValue = '';

    switch (column)
    {
        case 0:
            formattedValue = value ? value.toString() : '';
            break;

        case 1:
            formattedValue = EntitlementProductRequestTypeMap[value];
            break;

        case 2:
            formattedValue = Resources.getResource('panel.product.ProductStatus.Value.' + EntitlementProductRequestStatusMap[value]);
            break;

        case 3:
            formattedValue = !value ? "" : value.toString();
            break;

        case 4:
            formattedValue = DateTimeUtils.FormatToDateAndTime(new Date(value));
            break;

        default:
            formattedValue =
                value === null ||
                    value === '' ||
                    value === undefined ||
                    value === NaN
                    ? Resources.getResource('general.N_A')
                    : value.toString();
    }

    return { Value: value, FormattedValue: formattedValue };
};

EntitlementProductsItem.prototype.getColumnValue = function (column)
{
    let requestData = this.requestData;

    switch (column)
    {
        case 0:
            return requestData.Name;

        case 1:
            return requestData.ReqType;

        case 2:
            return requestData.ReqStatus;

        case 3:
            return requestData.Comment;

        case 4:
            return requestData.ReqTime;

        case 5:
            let product = DataCache.EntitlementManager.ProductsCache[requestData.Id];
            if (!product)
                return null
            let value = requestData.ReqStatus == EntitlementProductRequestStatus.Processing && product.ReqStatus == EntitlementProductRequestStatus.Processing && product.ReqTime == requestData.ReqTime;
            return value ? 1 : null;

        default:
            return 0;
    }
};

EntitlementProductsItem.prototype.GetColumnParams = function (column)
{
    let result = EntitlementProductsItem.columnsParams[column];

    return result
};

EntitlementProductsItem.columnsParams = [
    new ColumnParams("panel.product.ProductName", 70, 0, false, true, false),
    new ColumnParams("panel.product.ProductType", 70, 0, false, true, false),
    new ColumnParams("panel.product.ProductStatus", 70, 0, false, true, false),
    new ColumnParams("panel.product.Comment", 70, 0, false, false, false),
    new ColumnParams("panel.product.DateTime", 70, QuickTableColumnType.COL_DATE_SORT, false, true, false),
    new ColumnParams("panel.product.Cancel", 70, QuickTableColumnType.COL_DEFAULT, false, true, false)
];

EntitlementProductsItem.ListMenuIndex = [
    "panel.product.ProductName",
    "panel.product.ProductType",
    "panel.product.ProductStatus",
    "panel.product.Comment",
    "panel.product.DateTime",
    "panel.product.Cancel"
];